export const API_PATH_ApiTrafficStudyGenerateMockTrafficData = '/services/traffic-studies/apiTrafficStudyGenerateMockTrafficData';
